import { Tag }            from 'antd';
import { LAG_FK, LAG_GS } from 'AppConfig/Config';
import { formatDate }     from 'ClientService';
import Icon               from 'Common/Icon/Icon';
import React              from 'react';
import { useSelector }    from 'react-redux';
import { userContainsRole } from 'Redux/Query';

export const LastInteractionDate = ({ value, record }) => {
  const checkUserRole = useSelector(userContainsRole);

  const statementProcesses = [ ...record.statementProcesses ];
  if(statementProcesses.length === 0) {
    return (<i>---</i>)
  }
  statementProcesses.sort((a, b) => a.id > b.id ? a.id < b.id ? -1 : 0 : 1);
  const statement = statementProcesses[0];

  const renderReadDate = () => {
    if(!statement.readDate) {
      return null;
    }
    return (<Tag color="cyan" style={{ marginBottom: 6 }}><Icon type="info-circle" /> Gelesen: { formatDate(new Date(statement.readDate)) }</Tag>);
  }

  if(statement.answerDate) {
    return (
      <React.Fragment>
        { renderReadDate() }
        <Tag color="green"><Icon type="check" /> Beantwortet: { formatDate(new Date(statement.answerDate)) }</Tag>
      </React.Fragment>
    );
  }

  if(!statement.requestDate) {
    if(statement.requestInbox && checkUserRole([ LAG_GS, LAG_FK ])) {
      return (<Tag color="lime"><Icon type="inbox" /> Im Postfach </Tag>)
    }
    return (<i>---</i>)
  }

  return (
    <React.Fragment>
      {(statement.reminderDate) ?
        <Tag color="orange" style={{ marginBottom: 6 }}><Icon type="warning" /> Erinnert: { formatDate(new Date(statement.reminderDate)) }</Tag>
        : null
      }
      <Tag color="purple"><Icon type="clock-circle" /> Gesendet: { formatDate(new Date(statement.requestDate)) }</Tag>
      { renderReadDate() }
    </React.Fragment>
  );
}
